import React from 'react';
import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import dataApi from '../../apis/dataApi';
import { notify } from '../notificationSystem/actions';
import * as constants from './constants';
import * as actions from './actions';
import handleError from '../handleError';

export function* fetchPpi(action) {
  try {
    const id = action.payload;
    const response = yield call(dataApi.fetchPpi, id);
    const ppi = response.data;
    yield put(actions.fetchPpiDone(ppi));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppiFetchFail',
      put(actions.fetchPpiFail(error))
    );
  }
}

export function* fetchNewPpiAvailable(action) {
  try {
    const id = action.payload;
    const response = yield call(dataApi.fetchNewPPIAvilableData);
    yield put(actions.fetchNewPPIAvilableDataDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppiFetchFail',
      put(actions.fetchNewPPIAvilableDataFail(error))
    );
  }
}

export function* fetchPpis(action) {
  try {
    const { filter, type } = action.payload;
    const response = yield call(dataApi.fetchPpis, filter);
    // debugger
    // yield put(actions.fetchPpisDone(response.data));
    yield put(
      actions.fetchPpisDone(
        type ? { payload: response.data, type } : response.data
      )
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppisFetchFail',
      put(actions.fetchPpisFail(error))
    );
  }
}

export function* fetchMarketPpis(action) {
  try {
    const { marketCode } = action.payload;
    const response = yield call(dataApi.fetchMarketPpi, marketCode);
    yield put(actions.fetchMarketPpisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppisFetchFail',
      put(actions.fetchMarketPpisFail(error))
    );
  }
}

export function* fetchPpisRelatedToMarketPpsi(action) {
  try {
    const { marketCode, filter } = action.payload;
    const response = yield call(
      dataApi.fetchMarketUsedPpis,
      marketCode,
      filter
    );
    yield put(actions.fetchPpisRelatedToMarketPpsiDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppisFetchFail',
      put(actions.fetchPpisRelatedToMarketPpsiFail(error))
    );
  }
}

export function* fetchGlobalPpis({ payload = {} }) {
  try {
    const { filter } = payload;
    const response = yield call(dataApi.fetchGlobalPpis, filter);
    yield put(actions.fetchGlobalPpisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppisFetchGlobalFail',
      put(actions.fetchGlobalPpisFail(error))
    );
  }
}

export function* fetchPpisUpdate() {
  try {
    const response = yield call(dataApi.fetchPpisUpdate);
    // yield put(actions.fetchUpdatePpisDone(response.data));
    yield put(actions.fetchPpisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppisFetchUpdateFail',
      put(actions.fetchUpdatePpisFail(error))
    );
  }
}

export function* fetchGlobalPpisUpdate() {
  try {
    const response = yield call(dataApi.fetchGlobalPpisUpdate);
    // yield put(actions.fetchGlobalUpdatePpisDone(response.data));
    yield put(actions.fetchGlobalPpisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppisFetchGlobalUpdateFail',
      put(actions.fetchGlobalUpdatePpisFail(error))
    );
  }
}

export function* fetchGlobalPpiWithId(action) {
  try {
    const id = action.payload;
    const response = yield call(dataApi.fetchGlobalPpisWithId, id);
    yield put(actions.fetchGlobalPpisWithIdDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppisFetchGlobalFail',
      put(actions.fetchGlobalPpisWithIdFail(error))
    );
  }
}

export function* createPpiVariant(action) {
  try {
    const { id, status } = action.payload;
    const response = yield call(dataApi.fetchCreateVariantPpi, id, status);

    const { data } = response;
    yield put(actions.createPpiVariantDone(data));
    yield put(
      notify({
        message: [
          <FormattedMessage id="notify.ppiCreateVariantSuccess" key="success" />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppiCreateVariantFail',
      put(actions.createPpiVariantFail(error))
    );
  }
}

export function* deletePpi(action) {
  try {
    const id = action.payload;
    const response = yield call(dataApi.deletePpi, id);

    const { data } = response.data;
    const isResponseValid =
      data !== null && data !== undefined && data.length !== 0;
    yield put(actions.deletePpiDone(isResponseValid ? data : []));
    yield put(
      notify({
        message: response.data.message,
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppisDeleteFail',
      put(actions.deletePpiFail(error))
    );
  }
}

export function* createPpi(action) {
  const { itemCode, ppi, callback } = action.payload;
  try {
    const response = yield call(dataApi.createPpi, itemCode, ppi);
    yield put(actions.createPpiDone(response.data));
    if (callback) {
      callback(true);
    }
    yield put(
      notify({
        message: [
          <FormattedMessage id="notify.ppiSaveSuccess" key="success" />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppiSaveFail',
      put(actions.createPpiFail(error))
    );
    if (callback) {
      callback(false);
    }
  }
}

export function* savePpi(action) {
  const { id, ppi, callback } = action.payload;
  try {
    const response = yield call(dataApi.savePpi, id, ppi);
    yield put(actions.savePpiDone(response.data));
    if (callback) {
      callback(true);
    }
    yield put(
      notify({
        message: [
          <FormattedMessage id="notify.ppiSaveSuccess" key="success" />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppiSaveFail',
      put(actions.savePpiFail(error))
    );
    if (callback) {
      callback(false);
    }
  }
}

const ApiActionType = {
  PUBLISH: {
    dataApiMethod: dataApi.publishPpi,
    reduxActionDone: actions.publishPpiDone,
    reduxActionFail: actions.publishPpiFail,
    successMessage: 'notify.ppiPublishSuccess',
    failMessage: 'notify.ppiPublishFail'
  },
  UNPUBLISH: {
    dataApiMethod: dataApi.unpublishPpi,
    reduxActionDone: actions.unpublishPpiDone,
    reduxActionFail: actions.unpublishPpiFail,
    successMessage: 'notify.ppiUnpublishSuccess',
    failMessage: 'notify.ppiUnpublishFail'
  },
  CREATE_DRAFT: {
    dataApiMethod: dataApi.createDraftPpi,
    reduxActionDone: actions.createDraftPpiDone,
    reduxActionFail: actions.createDraftPpiFail,
    successMessage: 'notify.ppiCreateDraftSuccess',
    failMessage: 'notify.ppiCreateDraftFail'
  },
  MARKASUPTODATE: {
    dataApiMethod: dataApi.markAsUptoDatePpi,
    reduxActionDone: actions.markAsUptoDatePpiDone,
    reduxActionFail: actions.markAsUptoDatePpiFail,
    successMessage: 'notify.ppiMarkAsUptoDateSuccess',
    failMessage: 'notify.ppiMarkAsUptoDateFail'
  },
  IMPORT_IFOOD_UPDATE_PPI_API: {
    dataApiMethod: dataApi.importUpdatePpi,
    reduxActionDone: actions.importUpdatePpiDone,
    reduxActionFail: actions.importUpdatePpiFail,
    successMessage: 'notify.ppiImportUpdateSuccess',
    failMessage: 'notify.ppiImportUpdateFail'
  },
  IMPORT_GLOBAL_UPDATE_PPI_API: {
    dataApiMethod: dataApi.importGlobalPpiUpdate,
    reduxActionDone: actions.importGlobalUpdatePpiDone,
    reduxActionFail: actions.importGlobalUpdatePpiFail,
    successMessage: 'notify.ppiGlobalImportUpdateSuccess',
    failMessage: 'notify.ppiGlobalImportUpdateFail'
  },
  DISCARD_DRAFT_PPI: {
    dataApiMethod: dataApi.discardDraftPpi,
    reduxActionDone: actions.discardDraftPpiDone,
    reduxActionFail: actions.discardDraftPpiFail,
    successMessage: 'notify.ppsiDiscardDraftSuccess',
    failMessage: 'notify.ppsiDiscardDraftFail'
  }
};

function sendSuccessNotification(messageId) {
  return notify({
    message: [<FormattedMessage id={messageId} key="success" />],
    variant: 'success'
  });
}

function* performDataApiCall({ payload }, apiActionType) {
  try {
    const { id, data } = payload;
    const response = yield call(apiActionType.dataApiMethod, id, data);
    // console.log(apiActionType.reduxActionDone.name, response.data);
    // if(apiActionType.reduxActionDone.name === "importUpdatePpiDone"){
    //   response.data.inProgressPPIEnrichmentData.info['PL-PL'].presentationName =
    //   `updated ${response.data.inProgressPPIEnrichmentData.info['PL-PL'].presentationName}`
    //   response.data.inProgressPPIEnrichmentData.firstStorage='FSG2'
    //   response.data.inProgressPPIEnrichmentData.upToDate = true
    // }
    yield put(apiActionType.reduxActionDone(response.data));
    yield put(sendSuccessNotification(apiActionType.successMessage));
  } catch (error) {
    yield call(
      handleError,
      error,
      apiActionType.failMessage,
      put(apiActionType.reduxActionFail(error))
    );
  }
}

function* publishPpi(reduxAction) {
  console.log('Saga.publishPpi()', reduxAction);
  yield call(performDataApiCall, reduxAction, ApiActionType.PUBLISH);
}

function* unpublishPpi(reduxAction) {
  console.log('Saga.unpublishPpi()', reduxAction);
  yield call(performDataApiCall, reduxAction, ApiActionType.UNPUBLISH);
}

function* createDraftPpi(reduxAction) {
  console.log('Saga.createPpi()', reduxAction);
  yield call(performDataApiCall, reduxAction, ApiActionType.CREATE_DRAFT);
}

function* markAsUptoDatePpi(reduxAction) {
  console.log('Saga.createPpi()', reduxAction);
  yield call(performDataApiCall, reduxAction, ApiActionType.MARKASUPTODATE);
}

function* importUpdatePpi(reduxAction) {
  console.log('Saga.updatePpi()', reduxAction);
  yield call(
    performDataApiCall,
    reduxAction,
    ApiActionType.IMPORT_IFOOD_UPDATE_PPI_API
  );
}

function* importGlobalPpiUpdate(reduxAction) {
  console.log('Saga.updatePpi()', reduxAction);
  yield call(
    performDataApiCall,
    reduxAction,
    ApiActionType.IMPORT_GLOBAL_UPDATE_PPI_API
  );
}

// PPI DISCARD DRAFT
function* discardDraftPpi(reduxAction) {
  yield call(performDataApiCall, reduxAction, ApiActionType.DISCARD_DRAFT_PPI);
}

// Fetch non-market specific global PPI:s. Used for NIR Markets
export function* fetchGlobalPpisNir({ payload = {} }) {
  try {
    const { filter } = payload;
    const response = yield call(dataApi.fetchGlobalPpisNir, filter);
    yield put(actions.fetchGlobalPpisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppisFetchGlobalFail',
      put(actions.fetchGlobalPpisFail(error))
    );
  }
}

// Fetch global PPi IFS Market for local market
function* fetchGlobalPpisIfs(action) {
  const id = action.payload;

  try {
    const response = yield call(dataApi.fetchGlobalPublishedPpiIfs, id);
    yield put(actions.fetchGlobalPpiIfsDone(response.data));
  } catch (error) {
    // yield put(actions.fetchGlobalPpiIfsFail(error));
    yield put(actions.fetchGlobalPpiIfsDone([]));
  }
}

//Fetch global PPi variant
function* fetchGlobalPpiVariant(action) {
  const id = action.payload;

  try {
    const response = yield call(dataApi.fetchGlobalPpiVariant, id);
    yield put(actions.fetchGlobalPpiVariantDone(response.data));
  } catch (error) {
    yield put(actions.fetchGlobalPpiVariantFail(error));
    //yield put(actions.fetchGlobalPpiIfsDone([]));
  }
}
export default [
  takeLatest(constants.FETCH_PPI, fetchPpi),
  takeLatest(constants.FETCH_NEW_PPI_AVAILABLE, fetchNewPpiAvailable),
  takeLatest(constants.FETCH_PPIS, fetchPpis),
  takeLatest(constants.FETCH_MARKET_PPIS, fetchMarketPpis),
  takeLatest(constants.FETCH_MARKET_USED_PPIS, fetchPpisRelatedToMarketPpsi),
  takeLatest(constants.CREATE_PPI_VARIANT, createPpiVariant),
  takeLatest(constants.FETCH_PPIS_GLOBAL, fetchGlobalPpis),
  takeLatest(constants.FETCH_PPIS_GLOBAL_UPDATE, fetchGlobalPpisUpdate),
  takeLatest(constants.FETCH_PPIS_UPDATE, fetchPpisUpdate),
  takeLatest(constants.FETCH_GLOBAL_PPIS_WITH_ID, fetchGlobalPpiWithId),
  takeLeading(constants.CREATE_PPI, createPpi),
  takeLeading(constants.SAVE_PPI, savePpi),
  takeLeading(constants.PUBLISH_PPI, publishPpi),
  takeLeading(constants.UNPUBLISH_PPI, unpublishPpi),
  takeLeading(constants.CREATE_DRAFT_PPI, createDraftPpi),
  takeLeading(constants.MARKASUPTODATE_PPI, markAsUptoDatePpi),
  takeLeading(constants.IMPORT_IFOOD_UPDATE_PPI, importUpdatePpi),
  takeLeading(constants.IMPORT_GLOBAL_UPDATE_PPI, importGlobalPpiUpdate),
  takeLeading(constants.DISCARD_DRAFT_PPI, discardDraftPpi),
  takeLatest(constants.DELETE_PPI, deletePpi),
  takeLatest(constants.FETCH_PPIS_GLOBAL_NIR, fetchGlobalPpisNir),
  takeLatest(constants.FETCH_GLOBAL_PPI_IFS, fetchGlobalPpisIfs),
  takeLatest(constants.FETCH_GLOBAL_PPI_VARIANT, fetchGlobalPpiVariant)
];
